import { BehaviorSubject } from 'rxjs';

export class CurrentUser {
  private _userInfo: { id: string; name: string; email: string } | undefined;
  private userInfoSubject = new BehaviorSubject<{
    id: string;
    name: string;
    email: string;
  } | undefined>(undefined);
  currentUser$ = this.userInfoSubject.asObservable();

  get id(): string | undefined {
    return this._userInfo?.id;
  }

  get name(): string | undefined {
    return this._userInfo?.name;
  }

  get email(): string | undefined {
    return this._userInfo?.email;
  }

  get userInfo(): { id: string; name: string; email: string } | undefined {
    return this._userInfo;
  }

  set userInfo(user: { id: string; name: string; email: string }) {
    console.debug('Setting current user', user);
    this._userInfo = user;
    this.userInfoSubject.next(this._userInfo);
  }
}

export const currentUser = new CurrentUser();
